import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteRoleMutation} from 'api';
import {useSnackbar} from 'notistack';

function RoleDeleteIconButton({roleId}) {
  const [deleteRole, deleteRoleResult] = useDeleteRoleMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteRole(roleId).unwrap();
      enqueueSnackbar('Role deleted', {variant: 'success'});
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || 'Error deleting role', {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Role</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this role?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteRoleResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteRoleResult.isLoading}
            color="error"
            endIcon={deleteRoleResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteRoleResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default RoleDeleteIconButton;
